var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg16 = function Svg16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.137 9.303a.75.75 0 0 1 1.06 1.06L3.81 13.75H6a.75.75 0 0 1 0 1.5H2a1 1 0 0 1-.133-.013q-.008 0-.017-.003-.02-.005-.039-.011-.05-.012-.098-.03-.029-.014-.056-.03a.8.8 0 0 1-.187-.133.8.8 0 0 1-.12-.16q-.024-.041-.044-.084a.8.8 0 0 1-.056-.286v-4a.75.75 0 0 1 1.5 0v2.19zM14 1.75q.068 0 .132.012l.016.003q.02.005.04.011.05.012.098.03.044.021.083.045.086.047.161.119.082.085.133.187.016.027.03.056a.8.8 0 0 1 .057.287v4a.75.75 0 0 1-1.5 0V4.31L9.863 7.698a.75.75 0 0 1-1.06-1.06l3.386-3.387H10a.75.75 0 1 1 0-1.5z"
  })));
};
export default Svg16;